import { IS_IMPERSONATING } from 'constants/AuthConstant';
import tokenStorage from 'utils/tokenStorage';

/**
 * Permissions et rôle : métadonnées session (login) + token d'impersonation JWT (affichage / droits UI).
 */
class PermissionService {
  decodeToken(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split('')
          .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Error decoding token:', error);
      return null;
    }
  }

  getPermissions() {
    const isImpersonating = tokenStorage.getItem(IS_IMPERSONATING) === 'true';
    if (isImpersonating) {
      const impersonationToken = tokenStorage.getItem('impersonation_token');
      if (impersonationToken) {
        const decodedToken = this.decodeToken(impersonationToken);
        if (decodedToken && decodedToken.permissions) {
          const perms = Array.isArray(decodedToken.permissions) ? decodedToken.permissions : [];
          console.log('[PermissionService] Permissions from impersonation token:', perms);
          return perms;
        }
      }
    }

    try {
      const raw = tokenStorage.getItem('user_permissions') || '[]';
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  hasPermission(permission) {
    if (!permission) {
      return false;
    }

    const permissions = this.getPermissions();
    return permissions.includes(permission);
  }

  hasAnyPermission(permissions) {
    if (!permissions || permissions.length === 0) {
      return true;
    }

    const userPermissions = this.getPermissions();
    return permissions.some(permission => userPermissions.includes(permission));
  }

  hasAllPermissions(permissions) {
    if (!permissions || permissions.length === 0) {
      return true;
    }

    const userPermissions = this.getPermissions();
    return permissions.every(permission => userPermissions.includes(permission));
  }

  getUserRole() {
    const stored = tokenStorage.getItem('user_role');
    if (!stored) {
      return null;
    }
    return stored;
  }
}

const permissionService = new PermissionService();
export default permissionService;
